import React from 'react';
import { Form } from '../../../../Components/Form';
import { useHistory } from 'react-router-dom';
import { AptorApi } from '../../../../Api';
import { useIntl } from 'react-intl';
import { useFormField } from '../../../../Components/Form/FormField';
import { FormValues } from '../../../../Components/Form/Form.types';
import { Typography, Divider } from '@material-ui/core';
import { useStyles } from './Help.styles';

export const Help = () => {
  const history = useHistory();
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const descriptionField = useFormField({
    label: formatMessage({ id: 'form.helpDescription' }),
    name: 'description',
    type: 'text',
    multilineRows: 5,
    required: true,
  });

  const validFromDate = useFormField({
    label: formatMessage({ id: 'form.validFrom' }),
    name: 'validFromUTC',
    type: 'datetime',
    required: true,
  });

  const validToDate = useFormField({
    label: formatMessage({ id: 'form.validTo' }),
    name: 'validToUTC',
    type: 'datetime',
    required: true,
  });

  const handleSubmit = async (data: FormValues, api: AptorApi, onSuccess: (key: string) => void) => {
    await api.supportInvite(data);
    onSuccess('law-portal.settings.invitationSent');
    history.push('/law-portal/settings');
    descriptionField.clear();
    validFromDate.clear();
    validToDate.clear();
  };

  return (
    <>
      <Typography className={classes.description} variant="body2">
        {formatMessage({ id: 'law-portal.settings.help.description' })}
      </Typography>
      <Divider className={classes.divider} />
      <Form
        submit={handleSubmit}
        submitLabel={formatMessage({ id: 'form.send' })}
        groups={[
          {
            grid: {
              type: 'column',

              items: [{ type: 'row', items: [descriptionField, validFromDate, validToDate] }],
            },
          },
        ]}
      />
    </>
  );
};
